let mixins = {}
try {
  // noinspection NpmUsedModulesInstalled
  mixins = require('marketing/playcards/_mixins/buy-playcard-form').default
} catch (e) {
  //
}

export default mixins
